import React, { useState } from "react";
import { useHistory, Link } from "react-router-dom";
import {
  Container,
  Header,
  FormField,
  Input,
  Button,
  Alert,
  SpaceBetween,
  Box,
} from "@cloudscape-design/components";
import { useAuth } from "../context/AuthContext";
import PoweredByFooter from "../components/common/PoweredByFooter";

export default function Login() {
  const { login } = useAuth();
  const history = useHistory();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const companylogo = process.env.REACT_APP_CLIENT_LOGO || "/Assets/images/iWMS.png";

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username || !password) {
      setError("Please enter username and password.");
      return;
    }
    setError("");
    setLoading(true);
    try {
      const { passwordChangeRequired } = await login(username, password);
      history.push(passwordChangeRequired ? "/change-password" : "/");
    } catch (err) {
      setError(err.response?.data?.detail || "Login failed. Please check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={{ position: "fixed", bottom: 0, left: 0, right: 0 }}>
        <PoweredByFooter dark />
      </div>
      <div style={styles.card}>
        <SpaceBetween size="l">
          <Box textAlign="center">
            <img src={companylogo} alt="Company Logo" style={{ height: 50, marginBottom: 16 }} />
            <h1 style={styles.logo}>iWMS SmartOps</h1>
            <p style={styles.subtitle}>Warehouse Management Suite</p>
          </Box>

          <Container header={<Header variant="h2">Sign In</Header>}>
            <form onSubmit={handleSubmit}>
              <SpaceBetween size="m">
                {error && <Alert type="error">{error}</Alert>}

                <FormField label="Username">
                  <Input
                    value={username}
                    onChange={({ detail }) => setUsername(detail.value)}
                    placeholder="username"
                    autoFocus
                  />
                </FormField>

                <FormField label="Password">
                  <div style={{ position: "relative" }}>
                    <Input
                      type={showPassword ? "text" : "password"}
                      value={password}
                      onChange={({ detail }) => setPassword(detail.value)}
                      placeholder="••••••••"
                    />
                    <div style={{ position: "absolute", right: 8, top: "50%", transform: "translateY(-50%)" }}>
                      <Button variant="link" formAction="none" onClick={() => setShowPassword(!showPassword)}>
                        {showPassword ? "Hide" : "Show"}
                      </Button>
                    </div>
                  </div>
                </FormField>

                <Button
                  variant="primary"
                  formAction="submit"
                  loading={loading}
                  fullWidth
                >
                  Sign In
                </Button>

                <Box textAlign="center">
                  <span style={styles.linkText}>
                    Don't have an account?{" "}
                    <Link to="/register" style={styles.link}>
                      Register here
                    </Link>
                  </span>
                </Box>

                <Box textAlign="center">
                  <span style={styles.linkText}>
                    Are you an Administrator?{" "}
                    <Link to="/admin" style={styles.link}>
                      Admin Login
                    </Link>
                  </span>
                </Box>
              </SpaceBetween>
            </form>
          </Container>
        </SpaceBetween>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #0f1b2d 0%, #1b2f4b 100%)",
  },
  card: {
    width: "100%",
    maxWidth: 440,
    padding: "0 16px",
  },
  logo: {
    color: "#fff",
    fontSize: 28,
    fontWeight: 700,
    margin: 0,
    letterSpacing: 1,
  },
  subtitle: {
    color: "rgba(255,255,255,0.6)",
    marginTop: 4,
    fontSize: 14,
  },
  linkText: {
    fontSize: 14,
    color: "#666",
  },
  link: {
    color: "#0073bb",
    textDecoration: "none",
    fontWeight: 600,
  },
};
